import './Header.css';

const Header = ({ mode, title, subtitle, logoURL, color, onClick }) => {
  return (
    <header className='w-100'  style={{
      zIndex: 1000,
      display: mode === '3' ? 'none' : 'flex'
    }}>
      <div onClick={onClick}>
        {mode !== '3' && <img className='logo-header' src={logoURL} alt="logo" />}
      </div>
      <div className='spacer' />
      <div>
        <p className='p-title'>{title}</p>
        <p style={{
          color
        }} className='p-subtitle' >{subtitle}</p>
      </div>
    </header>
  )
}

export default Header;